import { ref } from "vue";
import { projectAuth } from "../firebase/config";
import router from "../router";

// refs
const error = ref(null);

// logout function
const logout = async () => {
  error.value = null;

  try {
    await projectAuth.signOut();
    await router.push({ name: "Login" });
  } catch (err) {
    console.log(err.message);
    error.value = err.message;
  }
};

const useLogout = () => {
  return { error, logout };
};

export default useLogout;
